import Head from "next/head";
import React, { type ComponentProps } from "react";
import BaseHubspotForm from "react-hubspot-form";

type Props = ComponentProps<typeof BaseHubspotForm>;

export const HubspotForm: React.FC<Props> = (props) => {
  return (
    <>
      <Head>
        {/* jQuery is required to watch hubspot form submissions.
            We don't want to include it in our bundle, so let's only load it when forms are shown. */}
        <script
          key="jQuery"
          async
          crossOrigin="anonymous"
          integrity="sha256-u7e5khyithlIdTpu22PHhENmPcRdFiHRjhAuHcs05RI="
          src="https://code.jquery.com/jquery-3.6.0.slim.min.js"
        ></script>
      </Head>

      <BaseHubspotForm {...props} />
    </>
  );
};
